"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _question = _interopRequireDefault(require("./question"));
var _condition = _interopRequireDefault(require("./condition"));
var _moduleMapper = _interopRequireDefault(require("../utils/module-mapper"));
var _content = _interopRequireDefault(require("./content"));
var _highlights = _interopRequireDefault(require("./highlights"));
var _introduction = _interopRequireDefault(require("./introduction"));
var _timeline = _interopRequireDefault(require("./timeline"));
var _helpSnippets = _interopRequireDefault(require("./help-snippets"));
var _accountSelection = _interopRequireDefault(require("./account-selection"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var permittedModulesMap = {
  content: _content["default"],
  introduction: _introduction["default"],
  highlights: _highlights["default"],
  timeline: _timeline["default"],
  helpSnippets: _helpSnippets["default"],
  accountSelection: _accountSelection["default"]
};
var createModules = function createModules(modules) {
  return (0, _moduleMapper["default"])(permittedModulesMap, modules);
};
var createJourneyStep = function createJourneyStep(_ref, section) {
  var fields = _ref.fields;
  var modulesForSite = (0, _utils.filterItemsBySite)((fields === null || fields === void 0 ? void 0 : fields.modules) || []);
  return {
    id: (0, _utils.getProp)(fields, 'id'),
    sectionId: (0, _utils.getProp)(section === null || section === void 0 ? void 0 : section.sys, 'id'),
    slug: (0, _utils.getProp)(fields, 'slug'),
    site: (0, _utils.getProp)(fields, 'site'),
    hideProgressBar: (0, _utils.getProp)(fields, 'hideProgressBar'),
    questions: fields !== null && fields !== void 0 && fields.questions ? (0, _utils.filterItemsBySite)(fields.questions).map(function (question) {
      return (0, _question["default"])(question);
    }) : [],
    modules: createModules(modulesForSite),
    continueButtonText: (0, _utils.getProp)(fields, 'continueButtonText'),
    conditions: (0, _utils.getProp)(fields, 'conditions') ? fields.conditions.map(function (condition) {
      return (0, _condition["default"])(condition);
    }) : null
  };
};
var _default = createJourneyStep;
exports["default"] = _default;